module.exports = __webpack_public_path__ + "img/24_44.6bf5d6e3.png";